export default "__VITE_ASSET__pBWDiUiT__"